import { NavLink } from "react-router-dom";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: "📊", end: true },
  { to: "/admin/products", label: "Products", icon: "💎" },
  { to: "/admin/orders", label: "Orders", icon: "📦" },
  { to: "/admin/vendor", label: "Vendor Dispatch", icon: "📦" },
  { to: "/admin/coupons", label: "Coupons", icon: "🎟️" },
  { to: "/admin/users", label: "Customers", icon: "👥" },
  { to: "/admin/consultations", label: "Consultations", icon: "🔮" },
  { to: "/admin/reviews", label: "Reviews", icon: "⭐" },
  { to: "/admin/blog", label: "Blog", icon: "📝" },
  { to: "/admin/newsletter", label: "Newsletter", icon: "✉️" },
  { to: "/admin/account", label: "Account", icon: "🔐" },
];

export default function Sidebar({ open, onNavigate }) {
  return (
    <aside className={`admin-sidebar ${open ? "open" : ""}`}>
      <h3>Celestial Admin</h3>
      <nav>
        {LINKS.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.end}
            onClick={onNavigate}
            className={({ isActive }) => (isActive ? "active" : undefined)}
          >
            <span className="nav-icon">{l.icon}</span>
            {l.label}
          </NavLink>
        ))}
      </nav>
      <a className="back-to-site" href="/" target="_blank" rel="noreferrer">
        ↗ View store
      </a>
    </aside>
  );
}
